import dynamic from 'next/dynamic'
import Image from 'next/image'

import CelebrationImg from '@/assets/images/storefronts/clashofclans/bonus-completed-celebration.png'

import { StoreTypography } from '../typography/StoreTypography'

import styles from './bonusCelebration.module.scss'

const UNTRANSLATED_title = 'Congratulations!'
const UNTRANSLATED_bonus_completed_1 = 'You’ve completed the Bonus Track!'
const UNTRANSLATED_bonus_completed_2 = 'Check back next season for more bonuses.'

const Confetti = dynamic(() => import('@/components/Animations/Confetti'), { ssr: false })

export const BonusCelebration = () => {
  return (
    <div className={styles.bonusCelebrationContainer}>
      <Confetti className={styles.confetti} />
      <StoreTypography tag="h2" textSize="lg" style="outlined">
        {UNTRANSLATED_title}
      </StoreTypography>
      <div className={styles.celebrationImg}>
        <Image src={CelebrationImg} alt="bonus-completed-celebration" fill />
      </div>
      <StoreTypography tag="h3" textSize="body" style="plain" overrideFont="supercellText">
        {UNTRANSLATED_bonus_completed_1}
        <br />
        {UNTRANSLATED_bonus_completed_2}
      </StoreTypography>
    </div>
  )
}
